/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-08 09:47:56
 */
import Router from 'vue-router'
import Vue from 'vue'
// 材料审核 现场校验路由
import staffRouter from './euc-staff/index'
// 现场控制
import onsideStaffRouter from './onside-staff/index'
// 抽取课件
import extractCourseware from './extract-courseware/index'
// 下载ppt
import download from './download/index'
// 直播管理
import live from './live/index'
Vue.use(Router)

// 静态路由
const constantRouter = [
  {
    path: '/',
    name: 'login',
    component: resolve => require(['@/views/login'], resolve),
    hidden: true
  },
  {
    path: '/staffFirstLogin',
    name: 'firstLogin',
    component: resolve => require(['@/views/login/FirstLogin'], resolve),
    hidden: true
  }
]

// 获取权限路由函数: type 登录的选择类型
const asyncRouter = [
  ...staffRouter,
  ...onsideStaffRouter,
  ...extractCourseware,
  ...download,
  ...live
]
// 创建路由实列
const createRouter = () =>
  new Router({
    mode: 'history', // history模式
    // scrollBehavior: () => ({ y: 0 }), // 路由跳转滚动条回到顶部
    routes: constantRouter
  })

const router = createRouter()

// 重置路由（退出登录等）
const resetRouter = () => {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

// 导出所有
export { constantRouter, asyncRouter, resetRouter }

export default router



// WEBPACK FOOTER //
// ./src/router/index.js